<template>
  <div class="calico-score-meter-page">
    <div class="calico-score-meter-container">
      <div>Dark Mode</div>
      <div class="calico-score-meter-row">
        <CalicoScoreMeter
          score="0"
          title="Poor"
        />
        <CalicoScoreMeter
          score="10"
          title="Very Low"
        />
        <CalicoScoreMeter
          score="30"
          title="Low"
        />
        <CalicoScoreMeter
          score="50"
          title="Low Medium"
        />
        <CalicoScoreMeter
          score="60"
          title="Medium"
        />
      </div>
      <div class="calico-score-meter-row">
        <CalicoScoreMeter
          score="70"
          title="Medium High"
        />
        <CalicoScoreMeter
          score="80"
          title="High"
        />
        <CalicoScoreMeter
          score="90"
          title="Very High"
        />
        <CalicoScoreMeter />
      </div>
      <div>Light Mode</div>
      <div class="calico-score-meter-row">
        <CalicoScoreMeter
          mode="light"
          score="0"
          title="Poor"
        />
        <CalicoScoreMeter
          mode="light"
          score="10"
          title="Very Low"
        />
        <CalicoScoreMeter
          mode="light"
          score="30"
          title="Low"
        />
        <CalicoScoreMeter
          mode="light"
          score="50"
          title="Low Medium"
        />
        <CalicoScoreMeter
          mode="light"
          score="60"
          title="Medium"
        />
      </div>
      <div class="calico-score-meter-row">
        <CalicoScoreMeter
          mode="light"
          score="70"
          title="Medium High"
        />
        <CalicoScoreMeter
          mode="light"
          score="80"
          title="High"
        />
        <CalicoScoreMeter
          mode="light"
          score="90"
          title="Very High"
        />
        <CalicoScoreMeter mode="light" />
      </div>
    </div>
  </div>
</template>
  
  <script lang="js">
  import CalicoScoreMeter from '@/components/pattern/scoreMeter/index.vue'
  export default {
    name: 'CalicoScoreMeterPage',
    components: {
      CalicoScoreMeter
    },
    data () {
      return {
        text1: '',
      }
    },
    watch: {
      text1 (value) {
        console.log(value)
      },
    }
  }
  </script>
  <style lang="scss">
  .calico-score-meter-page {
    display: flex;
    justify-content: center;
    align-items: center;
    .calico-score-meter-container {
      @include stack-space($space-large);
      width: 100%;
      .calico-score-meter-row {
        @include inline-space($space-large);
        background: gray;
        width: 100%;
      }
    }
  }
  </style>
  